// import { isCurrentAdActiveSS } from 'helpers/ads/utils';

import makeRequest from 'utils/makeRequest';
import { isCurrentAdActiveSS, isValidProperty } from 'helpers/ads/utils';
import { getJarvisFeedURL } from 'utils/common';
import cookies from 'utils/cookies';
import _get from 'lodash.get';

export const LayoutType = [
  'mwebminitv', // 0
  'webminitv', // 1
  'mwebInpage', // 2
  'webInpage', // 3
  'mwebLarge', // 4
  'mwebInpagePip', // 5
  'mwebPip', // 6
];
function getMinitvConfig(mdata, props) {
  const {
    isMobile,
    layoutOverrideConfig = {},
    jarvisLayoutConfig = {},
  } = props;

  if (mdata?.jmweb_setting && isMobile) {
    mdata = {
      ...mdata,
      ...mdata.jmweb_setting,
    };
  }
  const layoutConf = {
    ...layoutOverrideConfig,
    ...jarvisLayoutConfig,
  };
  if (!layoutConf.skipPageLvl) {
    return {
      ...mdata,
      ...layoutConf,
    };
  }
  return mdata;
}
export function getServerDefault(props) {
  const { serverMinitv } = props;
  const conf = getMinitvConfig(serverMinitv, props);

  // style - type 1 - Common | type2 - mwebLarge | type3 webInpage
  // Dockobservale - or undock
  // Sticky -
  const {
    bottomCtaText = '',
    ctaTarget = '_blank',
    redirectionType = 'all',
  } = props;
  return {
    bottomCtaText,
    ctaTarget,
    redirectionType,
    ...conf,
  };
}

function checkJarvis(conf, setting) {
  if (!conf) {
    return conf;
  }
  conf = getMinitvConfig(conf, setting);
  if (typeof window.checkJarvisIsAdActive === 'function') {
    return window.checkJarvisIsAdActive(conf);
  }
  const { isMobile, isUserPrime } = setting;
  const platform = isMobile ? 'mweb' : 'web';
  if (window.Times?.adsKeys) {
    const pageconf = { ...window.Times?.adsKeys, isMobile };
    const jsetting = isCurrentAdActiveSS(conf, pageconf);
    if (jsetting?.isAdActive === 0) {
      return null;
    }
  }
  if (isUserPrime && conf?.skipPrime) {
    return null;
  }
  return isValidProperty(conf?.platform, platform) ? conf : null;
}

const removeSplchFromStr = str => {
  try {
    if (typeof str === 'string') {
      return str.replace(/[^a-zA-Z0-9\-\/]/g, '').toLowerCase();
    }
    return str;
  } catch (e) {
    return str;
  }
};
export function fetchMiniTvDataV2(props) {
  const { isMobile } = props;
  let pageConfig = {};
  if (window?._dfpObj?.jclientFilterAllowed) {
    pageConfig = window?._dfpObj?.jclientFilterAllowed(isMobile) || {};
  } else {
    pageConfig = {
      Tmpl_SCN: window?.Times?.adsKeys?.Tmpl_SCN,
      platform: isMobile ? 'mweb' : 'web',
    };
  }
  let geoCode = cookies.get('geo_country') || window.geoCode;

  const {
    Tmpl_SCN: tmpl,
    SCN,
    SubSCN,
    Hyp1,
    Channel,
    LastSubSCN,
    geo,
    platform,
  } =
    pageConfig || {};
  geoCode = geoCode || geo;
  let path = tmpl ? `&tn=${tmpl}` : '';
  path += platform ? `&pl=${platform}` : '';

  path += SCN ? `&sn=${removeSplchFromStr(SCN)}` : '';
  path += SubSCN ? `&sn2=${removeSplchFromStr(SubSCN)}` : '';
  path += LastSubSCN ? `&sn3=${removeSplchFromStr(LastSubSCN)}` : '';
  path += Channel ? `&ch=${Channel}` : '';
  path += Hyp1 ? `&k=${removeSplchFromStr(Hyp1)}` : '';
  path += geo ? `&geo=${geoCode}` : '';

  const url = `${getJarvisFeedURL('/revenue/minitv_filter', path)}`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

const updateMinitvData = minitvData => ({
  ...minitvData,
  jActive: 1,
});
export const postReceiveMinitvData = (apidata = {}, props) => {
  try {
    const { data = {}, updateData } = apidata;
    const minitv = data;
    if (updateData?.length > 0) {
      updateData.forEach(item => {
        const targetObj = item?.targetName
          ? _get(minitv, item?.targetName)
          : minitv;
        if (targetObj && item) {
          Object.keys(item).forEach(key => {
            targetObj[key] = item[key];
          });
        }
      });
    }

    const isActive = checkJarvis(minitv, props);
    if (isActive && minitv?.videoId) {
      return updateMinitvData(minitv);
    }
  } catch (error) {
    // console.log('Error in postReceiveMinitvData', error);
  }
  return null;
};

export const getMinitvData = async props => {
  let minitvData = null;
  try {
    const jdata = await fetchMiniTvDataV2(props);
    minitvData = postReceiveMinitvData(jdata?.data, props);
  } catch (error) {
    /* empty */
  }
  return minitvData;
};
// dynamic
export function redirectionAllow(props) {
  const { jminiTvData, isMobile } = props;
  const { redirectionType } = jminiTvData;

  switch (redirectionType) {
    case 'all':
    case 'videoshow':
      return true;
    case 'mweb':
      return isMobile;
    case 'web':
      return !isMobile;
    default:
  }
  return false;
}
// one time config
export const getLayoutBasedOneTimeConfig = (props, playerClass) => {
  let { layoutType } = props;
  const { jOverrideConfig } = props;

  const { isMobile, layoutOverrideConfig } = props;
  if (!layoutType) {
    layoutType = isMobile ? LayoutType[0] : LayoutType[1];
  }
  if (jOverrideConfig?.layoutType) {
    layoutType = jOverrideConfig?.layoutType;
  }

  const w = [177, 400, 400, 300, 400, 400, 177];
  const webSsWrapperList = [0, 2, 3, 4, 5];
  const ind = LayoutType.indexOf(layoutType);

  const skipTranslateList = [5, 6];
  const skipOverBtnList = [5, 6, 3];

  const ssWrapper = webSsWrapperList.includes(ind);
  const skipTranslate = skipTranslateList.includes(ind);
  const skipOverLayBtn = skipOverBtnList.includes(ind);
  return {
    layoutType,
    divId: `j_minitv_player_id_2`,
    playerWidth: w[ind] || 400,
    ssWrapper,
    skipTranslate,
    skipOverLayBtn,
    playerClass,
    ...layoutOverrideConfig,
  };
};

export const getServerUISetup = (
  props,
  serverWrapper,
  isStyleActive,
  layoutSsConfig,
) => {
  const { wrapperProps } = props;
  const { skipTranslate } = layoutSsConfig;

  const d = {};
  if (!serverWrapper && !skipTranslate) {
    d.second = {
      'data-resizer-target': 'atf,cw',
    };
  }
  if (isStyleActive && wrapperProps) {
    d.ot = wrapperProps;
  }
  return {
    secondWrapper: d.second || {},
    otWrapper: d.ot || {},
  };
};
